import { slice } from '../slices/deepSearch';

const nameSpace = slice.name;

export const isLoading = (state: RootState) => state[nameSpace].isLoading;
export const targetTagId = (state: RootState) => state[nameSpace].targetTagId;
export const filterBy = (state: RootState) => state[nameSpace].filterBy;
export const selectedItemId = (state: RootState) => state[nameSpace].selectedItemId;
export const isIncludeAllTags = (state: RootState) => state[nameSpace].isIncludeAllTags;
export const data = (state: RootState) => state[nameSpace].data;
export const describe = (state: RootState) => state[nameSpace].describe;
export const deepQuery = (state: RootState) => state[nameSpace].deepQuery;
export const deepSearchTabIsAvailable = (state: RootState) => state[nameSpace].deepSearchTabIsAvailable;
export const videoTags = (state: RootState) => state[nameSpace].videoTags;
